
export const environmentConfig = {
    zmbIntegrationHost: 'https://mtn-zmb.zedgames.mobi/subscription',
    zedGamesHost: 'https://play.zedgames.mobi/player-details',
    zedGamesHEHost: 'http://mtn-zmb-he.zedgames.mobi',
}
